import { getNativeToken } from '@ui/constants/tokens';
import { toReadableValue } from '@ui/lib/bignumber';
import { isNil } from 'lodash-es';
import { useMemo } from 'react';
import { useAccount, useBalance } from 'wagmi';

import { useDataChainId } from './datachain';

export const useNativeToken = () => {
  const chainId = useDataChainId();

  return useMemo(() => getNativeToken(chainId), [chainId]);
};

export const useNativeTokenBalance = (options?: {
  refetchInterval?: number;
}) => {
  const { address } = useAccount();
  const chainId = useDataChainId();

  return useBalance({
    address,
    chainId,
    query: {
      refetchInterval: options?.refetchInterval,
      select: (data) => {
        if (isNil(data)) return undefined;

        return toReadableValue(data.value, data.decimals);
      },
    },
  });
};
